// Packages
import { useState, useEffect, React } from "react";
import { Link, useHistory } from "react-router-dom";
import moment from "moment";
import PropTypes from "prop-types";
// Material Ui
import { CircularProgress, Paper, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Toolbar from "@material-ui/core/Toolbar";
import { FaArrowLeft } from "react-icons/fa";
import blankProfile from "./images/blank-profile.png";
// Styles
import "./schoolAdmin.css";
import {
  getFromLocalStorage,
  setInToLocalStorage,
} from "../../utils/webStorage";
// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";
// Assets
import editIcon from "../../assets/images/editIcon.png";
// Services
import userService from "../../services/user.service";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import { useSelector } from "react-redux";
// Utils
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function SchoolNameScreen() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [schoolData, setSchoolData] = useState({});
  const loginRole = getFromLocalStorage("loginRole");
  const [submitting, setSubmitting] = useState(false);
  const history = useHistory();
  const school = document.getElementById("School");
  if (school) {
    school.classList.add("active");
  }
  let schoolId = getFromLocalStorage("schoolId");
  const { isDrawerOpen } = useSelector(
    (state) => state?.schoolAdminDashboardInformation
  );

  useEffect(() => {
    setSubmitting(true);

    userService
      .getSchoolDetails(schoolId)
      .then((response) => {
        setSchoolData(response.data.data);
        const { user } = response.data.data;
        if (loginRole != "COACH") {
          setInToLocalStorage("schoolName", user?.schoolName);
          setInToLocalStorage("schoolLogo", user?.uploadedLogo?.filePath);
          var userName = user?.firstName + " " + user?.lastName;
          setInToLocalStorage("loginUser", userName);
        }

        setSubmitting(false);
      })
      .catch((error) => {
        setSubmitting(false);
        console.error("There was an error!", error);
      });
  }, []);

  const handleNavigation = () => {
    let path = "";
    switch (loginRole) {
      case "SCHOOL ADMIN":
        path = "./schooladmindata";
        break;

      case "COACH":
        path = "./coachdashboard";

      default:
        break;
    }
    history.push(path);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      {loginRole == "SCHOOL ADMIN" || loginRole === "COACH" ? (
        <div>
          <div
            // className="content-layout p-0"
            className={
              isDrawerOpen ? "content-layout p-0" : "toggle-content-layout p-0"
            }
          >
            <SchoolAdminDashboard />
            <div className="dynamic-height">
              {!submitting && (
                <div>
                  <div className="row ">
                    <div className="col-12 col-lg-12 col-md-12 ">
                      <Toolbar className="mng-header">
                        <div className="d-flex-align-cent">
                          <FaArrowLeft
                            className="h25 text-dark pf-backbtn cp"
                            onClick={handleNavigation}
                          />
                          <p className="txt-blue bold fs-18">
                            Back To Home Page
                          </p>
                        </div>
                        <div className="">
                          {loginRole != "COACH" && (
                            <Link to="/profileEditPage">
                              <img
                                src={editIcon}
                                className="mr-4 fs-14 position-relative"
                                alt=""
                              />
                            </Link>
                          )}
                        </div>
                      </Toolbar>
                    </div>
                    <div className="container row pading-top pb-0 profile-container">
                      <div className="col-12 col-lg-7 col-md-12 white-card plr d-flex-align-cent pd-5">
                        <p className="small-btn profile-image-label">
                          School Logo
                        </p>
                        <div className="circular profile-img">
                          <img
                            className=" img-fluid "
                            src={
                              schoolData?.uploadedLogo?.filePath
                                ? schoolData?.uploadedLogo?.filePath
                                : blankProfile
                            }
                            alt="School Profile Image"
                          />
                        </div>
                        <div className="mg-left-10">
                          <span className="fs-22 black  semi-bold">
                            {schoolData?.schoolName}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="container row pading-top pb-0 profile-container">
                      <div className="col-12 col-lg-7 col-md-12 white-card plr d-flex-align-cent pd-5">
                        <p className="small-btn profile-image-label">
                          Profile Image
                        </p>
                        <div className="circular profile-img">
                          <img
                            className=" img-fluid "
                            src={
                              schoolData?.user?.profileUrl?.filePath
                                ? schoolData?.user?.profileUrl?.filePath
                                : blankProfile
                            }
                            alt="Your Profile Image"
                          />
                        </div>
                        <div className="mg-left-10">
                          <span className="fs-22 black  semi-bold">
                            {`${schoolData?.firstName} ${schoolData?.lastName}`}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="container row pading-top pb-0 profile-container">
                      <div class="col-12 col-lg-7 col-md-12 white-card plr">
                        <div class="clear10"></div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">School Type</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black">
                              {schoolData?.schoolType}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Admin Name</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black">
                              {schoolData?.firstName}&nbsp;
                              {schoolData?.lastName}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">State</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black">
                              {schoolData?.state}{" "}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Country</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black">
                              {schoolData?.country}
                            </label>
                          </div>
                        </div>

                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">
                              School-Address
                            </label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black">
                              {schoolData?.address ? schoolData?.address : "-"}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Plan</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black">
                              {schoolData?.plan ? schoolData?.plan : "-"}
                            </label>
                          </div>
                        </div>
                        <div class="clear10"></div>
                      </div>
                    </div>

                    <div className="container row pt-3 profile-container ">
                      <div class="col-12 col-lg-7 col-md-12 white-card w-100 plr">
                        <div class="clear10"></div>
                        <div class="row">
                          <label class="fs-18 semi-bold">OTHER DETAILS</label>
                        </div>
                        <div class="clear10"></div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Date Joined</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black profileLevel">
                              {moment(schoolData?.createdAt).format(
                                "MM/DD/YYYY"
                              )}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Email</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black profileLevel">
                              {schoolData?.email}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Contact</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black profileLevel">
                              {schoolData?.phoneNumber}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Sports</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black profileLevel">
                              {schoolData?.sport}
                            </label>
                          </div>
                        </div>
                        <div class="row ">
                          <div class="col-12 col-lg-4 col-md-4 fmlabel">
                            <label className="fs-18 medium">Play Level</label>
                          </div>
                          <div class="col-12 col-lg-8 col-md-8">
                            <label className="fs-18 semi-bold black profileLevel">
                              {schoolData?.playLevel}
                            </label>
                          </div>
                        </div>

                        <div class="clear10"></div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {submitting && (
                <div className="content-layout-loading-animation">
                  <div className="shadow bg-white position-absolute rounded-circle p-2 loading-background d-flex justify-content-center align-items-center">
                    <CircularProgress
                      className="rounded-circle"
                      color="success"
                      sx={{ fontSize: 10, color: "#002244" }}
                      disableShrink
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <PageNotFoundPage />
      )}
    </div>
  );
}

export default SchoolNameScreen;
